import PolicyPage from '../components/PolicyPage';

export default function ShippingPolicy() {
  return (
    <PolicyPage
      title="Shipping & Delivery Policy"
      subtitle="How BharatCart delivers from your village shop to your doorstep."
      lastUpdated="15 June 2026"
      sections={[
        { id: 'coverage', heading: 'Delivery Coverage', body: (
          <p>BharatCart delivers within a <b>5-km radius</b> of every listed shop (some categories, like hot meals, may cap at 3 km). Enter your PIN code or share your location on the homepage to see the shops that serve your address.</p>
        )},
        { id: 'timelines', heading: 'Delivery Timelines', body: (
          <>
            <p>Typical delivery times from order confirmation:</p>
            <ul className="list-disc list-inside space-y-1">
              <li><b>Kirana / groceries:</b> 30 – 60 minutes</li>
              <li><b>Fresh vegetables / dairy:</b> 30 – 45 minutes</li>
              <li><b>Bakery / hotels (hot meals):</b> 20 – 45 minutes</li>
              <li><b>Medical (non-Rx):</b> 30 – 60 minutes</li>
              <li><b>Prescription medicines:</b> After Rx verification, usually within 2 hours</li>
              <li><b>Electronics / mobile / cloth:</b> Same-day if ordered before 4 PM, next-day otherwise</li>
            </ul>
            <p>Shop working hours are shown on every store page. Orders placed outside working hours are queued and dispatched at the start of the next working day.</p>
          </>
        )},
        { id: 'fees', heading: 'Delivery Fees', body: (
          <p>Each shop sets its own delivery fee (typically ₹10 – ₹40 for a 5-km trip). The exact fee is shown at checkout <b>before</b> you pay. Orders above a shop's "min order" value usually qualify for <b>free delivery</b> — look for the green badge on the store page.</p>
        )},
        { id: 'confirmation', heading: 'Order Confirmation & Tracking', body: (
          <p>You receive an SMS + WhatsApp confirmation the moment the shop owner accepts your order, and again when it's dispatched. Track live status any time on your Order page — every state change (Placed → Preparing → Out for delivery → Delivered) is timestamped.</p>
        )},
        { id: 'otp', heading: 'Delivery-Handoff OTP', body: (
          <p>For your safety, delivery for high-value / medicinal orders requires a <b>6-digit OTP</b>. Share the OTP with the delivery agent only after you've inspected the goods. The OTP is generated with cryptographic randomness and is shown only in your Order page.</p>
        )},
        { id: 'address', heading: 'Address Requirements', body: (
          <>
            <p>A complete Indian address includes: full name, mobile number, house / flat number, street, village or ward, PIN code, and (optionally) a landmark near the drop point. Please double-check before placing an order.</p>
            <p>If the delivery agent cannot find you after 2 phone attempts, the order is marked "Undeliverable" and returned to the shop. A restocking fee (typically 15 %) may apply.</p>
          </>
        )},
        { id: 'perishables', heading: 'Perishables & Cold Chain', body: (
          <p>Vegetables, fruits, dairy and cooked food travel in insulated bags or with ice packs where applicable. Please inspect perishables at the doorstep — any complaint must be raised within 4 hours of delivery for a full refund (see the Refund Policy).</p>
        )},
        { id: 'failed', heading: 'Failed Deliveries', body: (
          <>
            <p>Reasons a delivery may fail:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Recipient unreachable / not available</li>
              <li>Wrong or incomplete address</li>
              <li>Recipient refused the order</li>
              <li>Region unsafe (flood, curfew, riot) — communicated in advance</li>
            </ul>
            <p>You will be notified via SMS / WhatsApp. Refunds follow the standard timeline in our Refund Policy.</p>
          </>
        )},
        { id: 'international', heading: 'International Shipping', body: (
          <p>BharatCart is India-only. We do not currently ship outside India.</p>
        )},
        { id: 'contact', heading: 'Delivery Support', body: (
          <p>Email <a href="mailto:delivery@bharatcart.org" className="text-[#0D47A1] hover:underline">delivery@bharatcart.org</a> · Call / WhatsApp <a href="tel:+911800000000" className="text-[#0D47A1] hover:underline">+91 1800-000-000</a>.</p>
        )},
      ]}
    />
  );
}
